import { render, staticRenderFns } from "./PrintShopConfigDetails.vue?vue&type=template&id=554a9a19&scoped=true&"
import script from "./PrintShopConfigDetails.vue?vue&type=script&lang=js&"
export * from "./PrintShopConfigDetails.vue?vue&type=script&lang=js&"
import style0 from "./PrintShopConfigDetails.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PrintShopConfigDetails.vue?vue&type=style&index=1&id=554a9a19&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554a9a19",
  null
  
)

export default component.exports